import { render, staticRenderFns } from "./TicketsSystemAdd.vue?vue&type=template&id=26c6575a&"
import script from "./TicketsSystemAdd.vue?vue&type=script&lang=js&"
export * from "./TicketsSystemAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports